import { ArrowLeftOnRectangleIcon } from "@heroicons/react/24/outline";
import classes from "./classes.module.scss";

export default function ArrowLeftOnRectangleOutlinedIcon() {
	return <ArrowLeftOnRectangleIcon className={classes["root"]} />;
}
